import { VueSignaturePad } from 'vue-signature-pad'

// vue-signature-pad 3 (Aşama 4.8). `VueSignaturePad` adı ve `saveSignature()`/`clearSignature()` ref
// sözleşmesi (ConsentForm/SignForm.vue) 2.x ile aynı.
export default {
  install(app) {
    app.component('VueSignaturePad', VueSignaturePad)
  }
}
